export default "__VITE_ASSET__Cvx5uvpg__"